// -------------------------------------------------------------------------------------------
// The goal of this file is to allow asynchronous importing of DevExpress components.
// If you import all classes directly in your components, DevExpress will be included in your bundle.
// But DevExpress components are huge (~600KB gzipped), so we want to load them asynchronously.
// -------------------------------------------------------------------------------------------
// HOW TO USE:
// 1. import DevExpress components ONLY from this file (never from '@devexpress' directly)
// 2. For components use `<DXRG.component_name />` (e.g. `<DXRG.Button />`), for instantiation use use `new DXRG.class_name()`

import type {
  Sorting,
  SortingDirection,
  Table as TableBase,
  TableColumnWidthInfo,
  VirtualTableState,
  Column,
  SortingState,
  RowDetailState,
  Grid as GridBase,
  IntegratedSorting,
  IntegratedFiltering,
  TableRowDetail as TableRowDetailBase,
  FilteringState,
  DataTypeProvider,
  SearchState,
  VirtualTableProps,
} from '@devexpress/dx-react-grid';
import type {
  Grid,
  GridProps,
  Table,
  TableHeaderRow,
  TableProps,
  VirtualTable,
  TableColumnResizing,
  TableRowDetail,
} from '@devexpress/dx-react-grid-material-ui';
export type {
  Sorting,
  SortingState,
  RowDetailState,
  SortingDirection,
  TableBase,
  TableColumnWidthInfo,
  Grid,
  GridProps,
  Table,
  TableHeaderRow,
  TableProps,
  VirtualTableState,
  Column,
  VirtualTable,
  TableColumnResizing,
  TableRowDetail,
  GridBase,
  IntegratedSorting,
  TableRowDetailBase,
  FilteringState,
  SearchState,
  VirtualTableProps,
};

export let DXRG: {
  TableBase: typeof TableBase;
  Grid: typeof Grid;
  Table: typeof Table;
  TableHeaderRow: typeof TableHeaderRow;
  VirtualTableState: typeof VirtualTableState;
  VirtualTable: typeof VirtualTable;
  SortingState: typeof SortingState;
  RowDetailState: typeof RowDetailState;
  TableColumnResizing: typeof TableColumnResizing;
  TableRowDetail: typeof TableRowDetail;
  IntegratedSorting: typeof IntegratedSorting;
  IntegratedFiltering: typeof IntegratedFiltering;
  FilteringState: typeof FilteringState;
  DataTypeProvider: typeof DataTypeProvider;
  SearchState: typeof SearchState;
} = {} as any;
let _promise: Promise<any> | null;
let _isLoaded: boolean;
let _error: any;

export function useReactDataGrid() {
  if (!_isLoaded) {
    if (!_promise) {
      _promise = initDataGrid();
    }
    // will trigger Suspense
    throw _promise;
  }
  if (_error) {
    throw _error;
  }
}

function initDataGrid() {
  return Promise.all([
    import('@devexpress/dx-react-grid').then((x) => {
      DXRG = { ...(x as any), ...DXRG };
    }),
    import('@devexpress/dx-react-grid-material-ui').then((x) => {
      DXRG = { ...DXRG, ...(x as any) };
    }),
  ])
    .finally(() => {
      _isLoaded = true;
    })
    .catch((e) => (_error = e));
}
